import "@pws/coquille-help-training/styles.css";
import {
  HelpProvider,
  useHelp,
  useHelpOptional,
  HelpButton,
  HelpDrawer,
  HelpPanel,
  PageHelpContent,
  TrainingHub,
  TrainingChecklist,
  TRAINING_ROLES,
} from "@pws/coquille-help-training";
import { injectCoquilleTokens } from "./injectCoquilleTokens.js";

injectCoquilleTokens();

export {
  HelpProvider,
  useHelp,
  useHelpOptional,
  HelpButton,
  HelpDrawer,
  HelpPanel,
  PageHelpContent,
  TrainingHub,
  TrainingChecklist,
  TRAINING_ROLES,
};
